import { Job } from '../types/job';

export const jobs: Job[] = [
  {
    id: 'charge-communication',
    title: 'Communications Officer',
    department: 'Communication',
    type: 'Volunteer',
    location: 'Hybrid',
    commitment: '8-10 hours per week',
    description: "We are looking for a passionate Communications Officer to join our team and help promote digital inclusion for students.",
    responsibilities: [
      "Manage the association's social media accounts",
      "Create engaging content (visuals, articles, newsletters)",
      "Develop and implement communication strategies",
      "Coordinate awareness campaigns",
      "Ensure consistent messaging across all channels"
    ],
    requirements: [
      "Student in communication, digital marketing, or related field",
      "Excellent writing skills in French",
      "Proficiency in design tools (Canva, Photoshop)",
      "Experience in social media management"
    ],
    skills: {
      required: [
        "Community Management",
        "Web Writing",
        "Graphic Design",
        "Project Management"
      ],
      preferred: [
        "Video Editing",
        "SEO",
        "Analytics",
        "Mailchimp"
      ]
    }
  },
  {
    id: 'charge-partenariat',
    title: 'Partnerships Officer',
    department: 'Marketing',
    type: 'Volunteer',
    location: 'Hybrid',
    commitment: '10-12 hours per week',
    description: "We are looking for a dynamic Partnerships Officer to develop and maintain strong relationships with our institutional and private partners.",
    responsibilities: [
      "Identify and contact potential partners",
      "Negotiate and establish partnerships",
      "Manage relationships with existing partners",
      "Organize networking events",
      "Track and report partnership outcomes"
    ],
    requirements: [
      "Student in business school or university",
      "Excellent interpersonal skills",
      "Negotiation skills",
      "Proficiency in Microsoft Office Suite"
    ],
    skills: {
      required: [
        "Communication",
        "Negotiation",
        "Project Management",
        "CRM"
      ],
      preferred: [
        "Associative Experience",
        "Knowledge of the EdTech sector",
        "LinkedIn Sales Navigator",
        "Data Analysis"
      ]
    }
  },
  {
    id: 'operateur-support',
    title: 'Support Operator',
    department: 'Technical Support',
    type: 'Volunteer',
    location: 'Remote',
    commitment: '6-8 hours per week',
    description: "We are looking for a Technical Support Operator to assist our members in resolving technical issues and optimizing their use of digital tools.",
    responsibilities: [
      "Respond to support requests via chat and email",
      "Deliver services to users",
      "Create and maintain technical documentation",
      "Train users on tools",
      "Contribute to the continuous improvement of support"
    ],
    requirements: [
      "Education in IT or equivalent experience",
      "Excellent communication skills",
      "Patience and teaching ability",
      "Regular availability"
    ],
    skills: {
      required: [
        "Technical Support",
        "Problem Solving",
        "Documentation",
        "Collaborative Tools"
      ],
      preferred: [
        "ITIL",
        "Zendesk",
        "HTML/CSS",
        "Scripting"
      ]
    }
  }
];

export const getJobById = (id: string): Job | undefined => {
  return jobs.find(job => job.id === id);
};